module.exports = __webpack_public_path__ + "img/low.cc883b08.svg";